import { CATEGORY_LABELS, type Category } from '../types/package';

/** Libellé français pour la valeur d’énumération `category` renvoyée par l’API. */
export function getCategoryLabel(category: string | null | undefined): string {
  if (category == null || category === '') return '—';
  if (Object.prototype.hasOwnProperty.call(CATEGORY_LABELS, category)) {
    return CATEGORY_LABELS[category as Category];
  }
  return category;
}
